// Cette valeur est modifiée lors du build
export const APP_VERSION_VALUE = '[VERSION_NUMBER]-[BUILD_NUMBER]'
export const BFF_KEY_VALUE = 'ah1MPO-izehIHD-QZZ9y88n-kku876'
